export const CORS_BYPASS: string = "https://cors-anywhere.herokuapp.com/";
// dev url
//export const BASE_API_URL = "https://dev-api-v3.ezcloud123.io";
// Environment variables configured via GitHub Actions workflow
//export const BASE_API_URL = "https://nfs8gfkn8a.execute-api.us-east-1.amazonaws.com/dev/";
// live url
//export const BASE_API_URL = "https://apiv3.ezcloud.co";
//trail url
// export const BASE_API_URL = " https://trial-apiv3.ezcloud.co/";
//test url
// Now using environment variable with dev-api-v4 URL as fallback
export const BASE_API_URL: string =
  import.meta.env.VITE_API_DEV_URL ||
  import.meta.env.VITE_API_V3_URL ||
  "https://dev-api-v4.ezcloudai.co";

export const LOGIN_URL: string = BASE_API_URL + "/user/login";
export const CREATE_CUSTOMER: string = BASE_API_URL + "/user/customerRegistration";
export const CREATE_PREMIUM_CUSTOMER: string = BASE_API_URL + "/user/createCustomer";
export const CREATE_TEAM_USER: string = BASE_API_URL + "/user/createTeamUser";
export const GET_INVOICE: string = BASE_API_URL + "/invoice/getInvoice";
export const GET_INVOICE_LIST: string = BASE_API_URL + "/invoice/getInvoiceList";
export const GET_USERS: string = BASE_API_URL + "/user/getUsers";
export const GET_TEAMDETAILS_BY_ID: string = BASE_API_URL + "/team/getTeamDetailsById";
export const FORGET_PASSWORD: string = BASE_API_URL + "/user/forGetPassword";
export const UPDATE_PASSWORD: string = BASE_API_URL + "/user/updatePassword";
export const GET_USER_BY_ID: string = BASE_API_URL + "/user/getUserById";
export const UPDATE_USER: string = BASE_API_URL + "/user/updateUser";
export const UPDATE_TEAM: string = BASE_API_URL + "/team/updateTeam";
export const UPDATE_SUPPLIER_ACH: string = BASE_API_URL + "/team/updateSupplierAch";
export const UPLOAD_FILE: string = BASE_API_URL + "/uploadFile/uploadFile";
export const GET_INVOICE_DETAILS: string = BASE_API_URL + "/invoice/getInvoiceById";
export const GUPDATE_INVOICE_DETAILS: string = BASE_API_URL + "/invoice/getInvoiceById";
export const DASHBOARD: string = BASE_API_URL + "/dashboard/getDashboard";
export const DASHBOARD_OVERVIEW: string = BASE_API_URL + "/dashboard/getDashboardOverview";
export const DASHBOARD_DAILYREPORT: string = BASE_API_URL + "/dashboard/getDailyCount";
export const DASHBOARD_SUPPLIER_STATISTICS: string =
  BASE_API_URL + "/dashboard/getSupplierStatistics";
export const DASHBOARD_WEEKLY_REPORT: string = BASE_API_URL + "/dashboard/GetWeeklyCount";
export const DASHBOARD_INVOICE_STATISTICS: string =
  BASE_API_URL + "/dashboard/GetInvoiceStatistics";
export const DASHBOARD_TEAM_STATISTICS: string =
  BASE_API_URL + "/dashboard/GetTeamMemberStatistics";
export const DASHBOARD_INVOICE_DISTRIBUTION: string =
  BASE_API_URL + "/dashboard/GetInvoiceDistribution";
export const DASHBOARD_APPROVAL_DISTRIBUTION: string =
  BASE_API_URL + "/dashboard/GetInvoiceApprovalDistribution";
export const UPDATE_INVOICE: string = BASE_API_URL + "/invoice/updateInvoice";
export const UPDATE_PO_FLAG: string = BASE_API_URL + "/invoice/updatePoFlag";
export const UPDATE_INVOICE_STATUS: string = BASE_API_URL + "/invoice/updateInvoiceStatus";
export const ACCESS_S3_FILE: string = BASE_API_URL + "/uploadFile/accessS3File";
export const TEAM_MEMBER_ASSIGN: string = BASE_API_URL + "/team/assignTeamMemberToSupplier";
export const GET_ASSIGNER_LIST: string = BASE_API_URL + "/team/getAssingerList";
export const GET_ASSIGNED_TEAM_LIST: string = BASE_API_URL + "/team/getAssingedTeamList";

export const SAVE_INVOICE_LINE_ITEMS: string = BASE_API_URL + "/invoice/saveInvoiceLineItems";

//Notification

export const SAVE_DEVICE: string = BASE_API_URL + "/notification/saveDevice";
export const DELETE_DEVICE: string = BASE_API_URL + "/notification/deleteDevice";
export const SAVE_NOTIFICATION_DETAILS: string =
  BASE_API_URL + "/notification/saveNotificationDetails";

//upload url for dev
//export const REUPLOAD_URL =
// "https://to77qk4lxa.execute-api.us-east-1.amazonaws.com/GetStartedLambdaProxyIntegration";
// upload url for live
// export const REUPLOAD_URL =
//   "https://kzewnk2xf5.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";
//trail url
// export const REUPLOAD_URL =
// "https://6b7t38qpn0.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";

//upload url — v4 native reupload endpoint (same for all environments)
export const REUPLOAD_URL: string = BASE_API_URL + "/uploadFile/reupload";

//export const REUPLOAD_URL =
//"https://kzewnk2xf5.execute-api.us-east-1.amazonaws.com/default/ezcloud-file-upload-handler";

export const VERIFY_EMAIL_URL: string = BASE_API_URL + "/user/verifyCustomerEmail";
export const NEXT_INVOICE_URL: string = BASE_API_URL + "/invoice/getNextInvoice";
export const INVOICE_LINE_LISTING: string = BASE_API_URL + "/invoice/getInvoiceLine";
export const GET_TABLE_VALUES_BY_ID: string = BASE_API_URL + "/invoice/getTableValuesById";
export const INVOICELINE_CREATE_URL: string = BASE_API_URL + "/invoice/createInvoiceLine";
export const INVOICE_LINE_DELETE_URL: string = BASE_API_URL + "/invoice/deleteInvoiceLine";
export const INVOICE_LINE_UPDATE_URL: string = BASE_API_URL + "/invoice/updateInvoiceLine";
export const LOCK_INVOICE_URL: string = BASE_API_URL + "/invoice/lockInvoice";
export const UNLOCK_INVOICE_URL: string = BASE_API_URL + "/invoice/unLockInvoice";
export const GET_LOCKED_INVOICES_URL: string = BASE_API_URL + "/invoice/getLockedInvoices";
export const GET_INVOICE_FIELDS: string = BASE_API_URL + "/invoice/getInvoiceFieldList";
export const GET_KEYVALUES_BY_SUPPLIERNAME: string =
  BASE_API_URL + "/invoice/getKeyValuesBySupplierName";
export const UPDATE_INVOICE_FIELDS: string = BASE_API_URL + "/invoice/saveInvoiceFieldList";
export const GENERATE_OTP: string = BASE_API_URL + "/user/generateOTP";
export const VERIFY_OTP: string = BASE_API_URL + "/user/verifyOTP";

export const UPDATE_SUPPLIER_STATUS: string = BASE_API_URL + "/supplier/updateSupplierStatus";

export const SUPPLIER_LISTING: string = BASE_API_URL + "/supplier/getSupplierRequest";
export const SUPPLIER_SITE_LISTING: string = BASE_API_URL + "/supplier/getSupplierSiteDetails";
export const SUPPLIER_LISTING_RECLASIFICATION: string =
  BASE_API_URL + "/supplier/getSupplierReclarificationDetails";

export const ADD_SUPPLIER_REQUEST_URL: string = BASE_API_URL + "/supplier/sendSupplierRequest";
export const ADD_SUPPLIER_SITE_URL: string = BASE_API_URL + "/supplier/saveSupplierSiteDetails";

export const USER_SIGN_OUT_URL: string = BASE_API_URL + "/user/signOut";
export const USER_EMAIL_LIST_URL: string = BASE_API_URL + "/user/getEntityUser";
export const NOTIFY_SUPPLIER_URL: string = BASE_API_URL + "/supplier/sendPixelatedEmail";

export const NOTIFY_APPROVER_URL: string = BASE_API_URL + "/team/notifyApprovers";

export const UPDATE_SUPPLIER_REQUEST_URL: string = BASE_API_URL + "/supplier/updateSupplierRequest";

export const UPDATE_SUPPLIER_SITE_URL: string =
  BASE_API_URL + "/supplier/updateSupplierSiteDetails";

//enhancement
export const DELETE_INVOICE_URL: string = BASE_API_URL + "/invoice/deleteInvoice";
export const PRE_SIGNED_URL: string = BASE_API_URL + "/uploadFile/preSignedS3Url";
export const DELETE_SUPPLIER_REQUEST: string = BASE_API_URL + "/supplier/deleteSupplierRequest";
export const DELETE_TEAM_MEMBER: string = BASE_API_URL + "/user/deleteUser";
export const UPDATE_EXCEPTION_STATUS: string = BASE_API_URL + "/team/updateInvoiceException";

export const SUPPLIER_RECLARIFICATION: string = BASE_API_URL + "/supplier/supplierReclarification";

//report
export const REPORT_URL: string = BASE_API_URL + "/report/getInvoiceReport";
export const INVOICE_REPORT_URL: string = BASE_API_URL + "/report/GetInvoiceReportTest";
export const TEAM_REPORT_URL: string = BASE_API_URL + "/report/GetTeamMemberReport";
export const SUPPLIER_REPORT_URL: string = BASE_API_URL + "/report/GetSupplierReport";
export const STANDARD_DEVIATION_URL: string = BASE_API_URL + "/report/invoiceAmountMetrics";
export const MONTH_WISE_DEVIATION_URL: string = BASE_API_URL + "/report/invoiceReceivedMetrics";
export const ROUNDED_INVOICES_URL: string = BASE_API_URL + "/report/invoiceRoundedAmountMetrics";
//Comment

export const CREATE_COMMENT_URL: string = BASE_API_URL + "/comment/createComment";
export const UPDATE_COMMENT_URL: string = BASE_API_URL + "/comment/updateComment";
export const COMMENT_LIST_URL: string = BASE_API_URL + "/comment/getComments";
export const DELETE_COMMENT_URL: string = BASE_API_URL + "/comment/deleteComment";
export const COMMENT_BY_ID_URL: string = BASE_API_URL + "/comment/getCommentById";
export const COMMENT_USER: string = BASE_API_URL + "/comment/getChatUser";
//audits
export const GET_AUDIT_URL: string = BASE_API_URL + "/invoice/getAudits";
export const SAVE_AUDIT: string = BASE_API_URL + "/invoice/saveAudit";
export const UPDATE_INV_PROCESS_TIME: string = BASE_API_URL + "/invoice/updateInvProcessingTime";

export const IS_NEW_USER_URL: string = BASE_API_URL + "/user/checkIsNewSupplier";

export const FORMAT_SETTING_URL: string = BASE_API_URL + "/invoice/saveSettings";
export const GET_FORMAT_SETTING_URL: string = BASE_API_URL + "/invoice/getSettings";

//Cron
export const SAVE_CRON_DETAILS: string = BASE_API_URL + "/crone/saveCronDetails";
export const UPDATE_CRON_DETAILS: string = BASE_API_URL + "/crone/updateCronDetails";
export const GET_CRONE_DETAILS: string = BASE_API_URL + "/crone/getCroneDetails";
export const GET_EXPORTED_LIST: string = BASE_API_URL + "/crone/getExportedList";

// export const GET_INSTANT_EXPORT = BASE_API_URL + "/crone/getInstantExport";
export const GET_INSTANT_EXPORT: string = BASE_API_URL + "/crone/getInstantExport?";
// "https://demo-cron.ezcloudai.co/cron/getInstantExport";

//new extraction
export const EXTRACTION_FORM_URL: string = BASE_API_URL + "/invoice/getFormValuesById";
export const TRAINING_DATASET_URL: string =
  BASE_API_URL + "/entityDataset/saveEntityTrainingDataset";

// Training data storage URL — the one canonical training-save endpoint.
// SAVE_TRAINING_DATASET_URL was removed 2026-04-25 after it was identified
// as an alias creating duplicate save calls — see
// docs/TRAINING-DATA-DATASETTYPE-FIX-DESIGN.md.
export const TRAINING_DATA_STORAGE_URL: string =
  import.meta.env.VITE_TRAINING_DATA_STORAGE_URL ||
  BASE_API_URL + "/entityDataset/saveEntityTrainingDataset";

// Get saved training data by supplier name
export const GET_TRAINING_BY_SUPPLIER_URL: string =
  BASE_API_URL + "/entityDataset/getTrainingDataset";

//resubmit
// Now using environment variable with pretest URL as fallback
export const RESUBMIT_INITIALIZED_INVOICE_URL: string = BASE_API_URL + "/invoice/reprocess";

export const GET_TRAINED_DATASET_URL: string = BASE_API_URL + "/invoice/getInvoiceLabels";

export const GET_SUPPLIER_LIST_URL: string =
  // BASE_API_URL + "/uploadFile/getSupplierList";
  BASE_API_URL + "/supplier/getSupplierDetails";

export const GET_SUPPLIER_LIST: string = BASE_API_URL + "/supplier/getSupplierDetails";

export const GET_EXCEPTION_HANDLER_ROLE_URL: string =
  BASE_API_URL + "/user/getExceptionHandlerRole";

export const GET_EXCEPTION_HANDLER_DETAILS: string =
  BASE_API_URL + "/user/getExceptionHandlerDetails";

export const SAVE_INVOICE_EXCEPTION: string = BASE_API_URL + "/team/saveInvoiceException";

export const GET_INVOICE_EXCEPTION_LIST: string = BASE_API_URL + "/team/getExceptionInvoice";

export const IMPORT_GLCODE: string = BASE_API_URL + "/GLcode/importGLcode";

export const GET_TAG_VALUE: string = BASE_API_URL + "/GLcode/getTagValue";

export const SAVE_GLCODE_TAGVALUE: string = BASE_API_URL + "/GLcode/glCodeTagValue";

export const GET_ASSIGNED_GLCODE_VALUE: string = BASE_API_URL + "/GLcode/getAssignedGLcodeValue";

export const GET_GLCODE: string = BASE_API_URL + "/GLcode/generateGlCode";
export const DELETE_GLCODE: string = BASE_API_URL + "/GLcode/deleteGLcode";

// GL Segments
export const GL_SEGMENT_CONFIG: string = BASE_API_URL + "/GLcode/segments/config";
export const GL_SEGMENT_VALUES: string = BASE_API_URL + "/GLcode/segments/values";
export const GL_SEGMENT_VALIDATE: string = BASE_API_URL + "/GLcode/segments/validate";
// Tax Region
export const TAX_REGION_CONFIG: string = BASE_API_URL + "/taxRegion/config";
export const TAX_REGION_TAX_TYPE: string = BASE_API_URL + "/taxRegion/taxType";
export const TAX_REGION_PRESET: string = BASE_API_URL + "/taxRegion/preset";
export const TAX_REGION_PRESETS: string = BASE_API_URL + "/taxRegion/presets";
export const TAX_REGION_INVOICE: string = BASE_API_URL + "/taxRegion/invoice";
export const TAX_REGION_INVOICE_BULK: string = BASE_API_URL + "/taxRegion/invoice/bulk";
export const VALIDATE_TWO_FACTOR_AUTH: string = BASE_API_URL + "/user/verify2faAuthenticationCode";
export const FORGET_TWO_FACTOR_AUTH: string = BASE_API_URL + "/user/forgetTwoFaAuthenticationCode";
export const RESEND_EMAIL: string = BASE_API_URL + "/supplier/resendSupplierRequest";
export const UPDATE_TWOFAAUTHENTICATION: string =
  BASE_API_URL + "/user/updateTwoFaAuthenticationCode";

export const EXCEPTION_NEXT_INVOICE_URL: string = BASE_API_URL + "/team/getNextExceptionInvoice";
export const UPDATE_IS_ERP: string = BASE_API_URL + "/crone/updateIsErp";

export const GET_NOTIFICATION_URL: string = BASE_API_URL + "/notification/getNotificationDetails";

export const ADD_SUB_SUPPLIER: string = BASE_API_URL + "/user/createTeamUser";

//Non-Duplicate
export const NON_DUPLICATE_URL: string = BASE_API_URL + "/invoice/nonDuplicateInvoice";

// Expense Module — Phase 1
export const EXPENSE_CLAIMS: string = BASE_API_URL + "/expense/claims";
export const EXPENSE_CLAIMS_MINE: string = BASE_API_URL + "/expense/claims/mine";
export const EXPENSE_CLAIMS_PENDING: string = BASE_API_URL + "/expense/claims/pending-approval";
export const expenseClaimByIdUrl = (id: number): string => `${BASE_API_URL}/expense/claims/${id}`;
export const expenseClaimSubmitUrl = (id: number): string =>
  `${BASE_API_URL}/expense/claims/${id}/submit`;
export const expenseClaimApproveUrl = (id: number): string =>
  `${BASE_API_URL}/expense/claims/${id}/approve`;
export const expenseClaimRejectUrl = (id: number): string =>
  `${BASE_API_URL}/expense/claims/${id}/reject`;
export const expenseClaimCommentUrl = (id: number): string =>
  `${BASE_API_URL}/expense/claims/${id}/comment`;
export const expenseClaimReimburseUrl = (id: number): string =>
  `${BASE_API_URL}/expense/claims/${id}/reimburse`;
export const expenseReceiptsUrl = (id: number): string =>
  `${BASE_API_URL}/expense/claims/${id}/receipts`;
export const expenseReceiptByIdUrl = (cid: number, rid: number): string =>
  `${BASE_API_URL}/expense/claims/${cid}/receipts/${rid}`;
export const expenseReceiptOcrUrl = (cid: number, rid: number): string =>
  `${BASE_API_URL}/expense/claims/${cid}/receipts/${rid}/ocr`;
export const expenseAuditUrl = (id: number): string => `${BASE_API_URL}/expense/claims/${id}/audit`;
export const EXPENSE_CATEGORIES: string = BASE_API_URL + "/expense/categories";

// EBS / ERP Supplier Sync
export const SUPPLIER_SYNC_TRIGGER_URL: string = BASE_API_URL + "/supplierSync/trigger";
export const SUPPLIER_SYNC_UPLOAD_URL: string = BASE_API_URL + "/supplierSync/upload";
export const SUPPLIER_SYNC_STATUS_URL: string = BASE_API_URL + "/supplierSync/status";
export const SUPPLIER_SYNC_HISTORY_URL: string = BASE_API_URL + "/supplierSync/history";
export const SUPPLIER_SYNC_SUPPLIERS_URL: string = BASE_API_URL + "/supplierSync/suppliers";
export const SUPPLIER_SYNC_SITES_URL: string = BASE_API_URL + "/supplierSync/sites";
export const SUPPLIER_SYNC_CONFIG_URL: string = BASE_API_URL + "/supplierSync/config";
export const SEARCH_EBS_SUPPLIERS_URL: string = BASE_API_URL + "/supplierSync/suppliers/search";
// Alias used by OIC Sync components (same endpoint as SEARCH_EBS_SUPPLIERS_URL)
export const SEARCH_ERP_SUPPLIERS_URL: string = BASE_API_URL + "/supplierSync/suppliers/search";
export const GET_EBS_SUPPLIER_SITES_BY_NAME_URL: string =
  BASE_API_URL + "/supplierSync/suppliers/byName/sites";
// Alias used by OIC Sync components (same endpoint as GET_EBS_SUPPLIER_SITES_BY_NAME_URL)
export const GET_ERP_SUPPLIER_SITES_BY_NAME_URL: string =
  BASE_API_URL + "/supplierSync/suppliers/byName/sites";
export const RESOLVE_ABN_URL: string = BASE_API_URL + "/supplierSync/suppliers/resolveABN";

// OIC Invoice Export
export const OIC_EXPORT_TRIGGER_URL: string = BASE_API_URL + "/oicExport/trigger";
export const OIC_EXPORT_POLL_URL: string = BASE_API_URL + "/oicExport/pollResponses";
export const OIC_EXPORT_STATUS_URL: string = BASE_API_URL + "/oicExport/status";
export const OIC_EXPORT_HISTORY_URL: string = BASE_API_URL + "/oicExport/history";
export const OIC_EXPORT_REQUEUE_URL: string = BASE_API_URL + "/oicExport/requeue";

// Supplier Documents (HACOV)
export const ADD_SUPPLIER_DOCUMENT: string = BASE_API_URL + "/supplier/addSupplierDocument";
export const GET_SUPPLIER_DOCUMENTS: string = BASE_API_URL + "/supplier/getSupplierDocuments";
export const RENAME_SUPPLIER_DOCUMENT: string = BASE_API_URL + "/supplier/renameSupplierDocument";
export const DELETE_SUPPLIER_DOCUMENT: string = BASE_API_URL + "/supplier/deleteSupplierDocument";

// Yardi Integration (HACOV)
export const YARDI_DETAILS: string = BASE_API_URL + "/invoice/getYardiDetails";
export const ALLOWED_CASH_AMOUNT: string = BASE_API_URL + "/invoice/getAllowedCashAccount";
export const GET_EXPENSE_ACCOUNT: string = BASE_API_URL + "/invoice/getExpenseAccount";

// Invoice Line (multi-delete)
export const DELETE_MULTIPLE_INVOICE_LINE: string =
  BASE_API_URL + "/invoice/deleteMultipleInvoiceLine";

// Notification bulk update
export const UPDATE_NOTIFICATIONS: string =
  BASE_API_URL + "/notification/UpdateMultipleNotificationDetails";

// Feature Flags
export const GET_FEATURE_FLAGS_URL: string = BASE_API_URL + "/team/getFeatureFlags";

// Language / i18n
export const GET_AVAILABLE_LANGUAGES_URL: string = BASE_API_URL + "/team/getAvailableLanguages";
export const UPDATE_LANGUAGE_SETTINGS_URL: string = BASE_API_URL + "/team/updateLanguageSettings";
export const UPDATE_INVOICE_DEFAULTS_URL: string = BASE_API_URL + "/team/updateInvoiceDefaults";
export const UPDATE_LANGUAGE_PREFERENCE_URL: string =
  BASE_API_URL + "/user/updateLanguagePreference";

// SSO
export const SSO_CHECK_URL: string = BASE_API_URL + "/sso/check";
export const SSO_AUTHORIZE_URL: string = BASE_API_URL + "/sso/authorize";
export const SSO_CONFIG_URL: string = BASE_API_URL + "/sso/config";
export const SSO_TEST_URL: string = BASE_API_URL + "/sso/test";
export const SSO_AD_GROUPS_URL: string = BASE_API_URL + "/sso/adGroups";

// Permissions
export const GET_PERMISSION_CATALOG_URL: string = BASE_API_URL + "/permission/catalog";
export const GET_ROLES_URL: string = BASE_API_URL + "/permission/roles";
export const GET_USER_PERMISSIONS_URL: string = BASE_API_URL + "/permission/user";
export const UPDATE_USER_PERMISSIONS_URL: string = BASE_API_URL + "/permission/user/permissions";
export const UPDATE_USER_ROLE_URL: string = BASE_API_URL + "/permission/user/role";
export const GET_PERMISSION_SETS_URL: string = BASE_API_URL + "/permission/sets";
export const APPLY_PERMISSION_SET_URL: string = BASE_API_URL + "/permission/sets/apply";

// Out of Office
export const GET_OOO_STATUS_URL: string = BASE_API_URL + "/user/getOutOfOfficeStatus";
export const SET_OOO_URL: string = BASE_API_URL + "/user/setOutOfOffice";
export const GET_ELIGIBLE_DELEGATES_URL: string = BASE_API_URL + "/user/getEligibleDelegates";
export const GET_OOO_LIST_URL: string = BASE_API_URL + "/user/getOutOfOfficeList";
export const ADMIN_SET_OOO_URL: string = BASE_API_URL + "/user/adminSetOutOfOffice";
export const ADMIN_CANCEL_OOO_URL: string = BASE_API_URL + "/user/adminCancelOutOfOffice";
export const GET_DELEGATION_LOG_URL: string = BASE_API_URL + "/user/getDelegationLog";

// Notification Settings
export const GET_NOTIFICATION_SETTINGS_URL: string = BASE_API_URL + "/user/getNotificationSettings";
export const UPDATE_NOTIFICATION_SETTINGS_URL: string =
  BASE_API_URL + "/user/updateNotificationSettings";
export const GET_TEAM_NOTIFICATION_SETTINGS_URL: string =
  BASE_API_URL + "/user/getTeamNotificationSettings";
export const UPDATE_TEAM_NOTIFICATION_SETTINGS_URL: string =
  BASE_API_URL + "/user/updateTeamNotificationSettings";

// User management
export const RESEND_WELCOME_EMAIL_URL: string = BASE_API_URL + "/user/resendWelcomeEmail";
export const RESET_PASSWORD_URL: string = BASE_API_URL + "/user/resetPasswordByAdmin";
export const GET_ADMIN_COUNT_URL: string = BASE_API_URL + "/user/getAdminCount";

// Hard Delete User
export const HARD_DELETE_TEAM_MEMBER: string = BASE_API_URL + "/user/hardDeleteUser";

// Revalidate Invoice
export const REVALIDATE_INVOICE_URL: string = BASE_API_URL + "/invoice/revalidate";

// Workflow
export const WORKFLOW_APPROVE_URL: string = BASE_API_URL + "/workflow/approveInvoice";
export const WORKFLOW_SEND_BACK_URL: string = BASE_API_URL + "/workflow/sendBackInvoice";
export const WORKFLOW_MY_APPROVALS_URL: string = BASE_API_URL + "/workflow/getMyApprovals";
export const WORKFLOW_MY_HISTORY_URL: string = BASE_API_URL + "/workflow/getMyApprovalHistory";
export const WORKFLOW_INVOICES_BY_QUEUE_URL: string = BASE_API_URL + "/workflow/getInvoicesByQueue";
export const WORKFLOW_QUEUES_URL: string = BASE_API_URL + "/workflow/getQueues";
export const WORKFLOW_USER_ASSIGNMENTS_URL: string =
  BASE_API_URL + "/workflow/getUserQueueAssignments";
export const WORKFLOW_UPDATE_ASSIGNMENTS_URL: string =
  BASE_API_URL + "/workflow/updateUserQueueAssignments";
export const WORKFLOW_QUEUE_USERS_URL: string = BASE_API_URL + "/workflow/getQueueUsers";

// Budget Holder Routing
export const BUDGET_HOLDER_CONFIG_URL: string = BASE_API_URL + "/workflow/budgetHolder/config";
export const BUDGET_HOLDER_ASSIGNMENTS_URL: string =
  BASE_API_URL + "/workflow/budgetHolder/assignments";
export const BUDGET_HOLDER_PROXIES_URL: string = BASE_API_URL + "/workflow/budgetHolder/proxies";
export const BUDGET_HOLDER_MY_QUEUE_URL: string = BASE_API_URL + "/workflow/budgetHolder/myQueue";
export const THRESHOLD_RULES_URL: string = BASE_API_URL + "/workflow/thresholdRules";

// JIT Access
export const JIT_REQUEST_URL: string = BASE_API_URL + "/jit/request";
export const JIT_REQUESTS_URL: string = BASE_API_URL + "/jit/requests";
export const JIT_MY_REQUESTS_URL: string = BASE_API_URL + "/jit/my-requests";
export const JIT_APPROVE_URL: string = BASE_API_URL + "/jit/approve";
export const JIT_DENY_URL: string = BASE_API_URL + "/jit/deny";
export const JIT_CANCEL_URL: string = BASE_API_URL + "/jit/cancel";
export const JIT_REVOKE_URL: string = BASE_API_URL + "/jit/revoke";

// Microsoft Teams Integration
export const TEAMS_SETTINGS_URL: string = BASE_API_URL + "/teams/settings";
export const TEAMS_STATUS_URL: string = BASE_API_URL + "/teams/status";
export const TEAMS_USER_SETTINGS_URL: string = BASE_API_URL + "/teams/user/settings";
export const TEAMS_TEST_URL: string = BASE_API_URL + "/teams/test";

// Slack Integration
export const SLACK_SETTINGS_URL: string = BASE_API_URL + "/slack/settings";
export const SLACK_STATUS_URL: string = BASE_API_URL + "/slack/status";
export const SLACK_USER_SETTINGS_URL: string = BASE_API_URL + "/slack/user/settings";
export const SLACK_TEST_URL: string = BASE_API_URL + "/slack/test";
export const SLACK_OAUTH_URL: string = BASE_API_URL + "/slack/oauth/callback";
